/* Brano · ajustes oct 2026: menú del celular, receta de outfit ampliada y popup de packs */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const lock = (on) => document.body.classList.toggle('locked', on);

  /* ---------- menú del celular: bloquear el fondo, Escape y foco ---------- */
  const menu = $('#menu'), menuBtn = $('#menuBtn');
  if (menu && menuBtn) {
    const close = () => { menu.classList.remove('open'); lock(false); menuBtn.setAttribute('aria-expanded', 'false'); };
    menuBtn.addEventListener('click', () => { lock(true); const c = $('#menuClose'); c && setTimeout(() => c.focus(), 60); });
    $('#menuClose') && $('#menuClose').addEventListener('click', () => lock(false));
    $$('a', menu).forEach((a) => a.addEventListener('click', () => lock(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.classList.contains('open')) close(); });
  }

  /* ---------- arma tu outfit: receta con calce, cómo va y reloj ---------- */
  $$('[data-outfit]').forEach((box) => {
    const receta = $('[data-receta]', box); if (!receta) return;
    const row = (k, v) => (v ? `<div><dt>${k}</dt><dd>${v}</dd></div>` : '');
    const render = (b) => {
      receta.innerHTML = row('Arriba', b.dataset.title) +
        row('Calce', b.dataset.fit) +
        row('Cómo va', b.dataset.tuck) +
        row('Pantalón', b.dataset.pants) +
        row('Cinturón', b.dataset.belt) +
        row('Zapatos', b.dataset.shoes) +
        row('Reloj', b.dataset.watch) +
        row('Para', b.dataset.when) +
        row('También va con', b.dataset.alt);
    };
    $$('.pk', box).forEach((b) => b.addEventListener('click', () => render(b)));
    const on = $('.pk[aria-pressed="true"]', box) || $('.pk', box);
    on && render(on);
  });

  /* ---------- popup de packs ---------- */
  const pop = $('[data-pack-pop]');
  if (pop) {
    const KEY = 'brano_packs_visto';
    let seen = false; try { seen = sessionStorage.getItem(KEY) === '1'; } catch (_) {}
    let last = null, timer = null, shown = false;
    const open = () => {
      if (!pop.hidden) return;
      shown = true; clearTimeout(timer); last = document.activeElement;
      pop.hidden = false; requestAnimationFrame(() => pop.classList.add('on')); lock(true);
      try { sessionStorage.setItem(KEY, '1'); } catch (_) {}
      const x = $('.pp-x', pop); x && x.focus({ preventScroll: true });
    };
    const close = () => {
      pop.classList.remove('on'); lock(false);
      setTimeout(() => { pop.hidden = true; }, reduce ? 0 : 320);
      last && last.focus && last.focus({ preventScroll: true });
    };
    $$('[data-pp-close]', pop).forEach((b) => b.addEventListener('click', close));
    $$('[data-pp-go]', pop).forEach((a) => a.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) close(); });
    $$('[data-pp-open]').forEach((b) => b.addEventListener('click', open));

    const tabs = $$('[data-pp-tab]', pop), panels = $$('.pp-slide', pop);
    const show = (i) => { tabs.forEach((t, k) => t.setAttribute('aria-selected', String(k === i))); panels.forEach((p, k) => { p.hidden = k !== i; }); };
    tabs.forEach((t, i) => t.addEventListener('click', () => show(i)));

    pop.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const f = $$('button, a[href]', pop).filter((el) => !el.closest('[hidden]'));
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    const hero = $('[data-hero-track]'), chip = $('.pp-chip');
    if (chip) {
      const tog = () => chip.classList.toggle('show', !hero || scrollY > hero.offsetHeight * 0.75);
      addEventListener('scroll', tog, { passive: true }); tog();
    }
    const design = window.Shopify && window.Shopify.designMode;
    if (!seen && !design) {
      timer = setTimeout(open, (Number(pop.dataset.delay) || 8) * 1000);
      if (hero) {
        const onS = () => {
          if (shown) { removeEventListener('scroll', onS); return; }
          if (scrollY > hero.offsetHeight * 0.9) { removeEventListener('scroll', onS); open(); }
        };
        addEventListener('scroll', onS, { passive: true });
      }
    }
    document.addEventListener('shopify:section:select', (e) => { if (e.target.contains(pop)) { pop.hidden = false; pop.classList.add('on'); } });
    document.addEventListener('shopify:section:deselect', (e) => { if (e.target.contains(pop)) { pop.classList.remove('on'); pop.hidden = true; lock(false); } });
  }
})();